export default __webpack_public_path__ + "static/media/img_5.5522e659.jpg";